<div dir="ltr" class="rendered-content-container">
    <router-outlet></router-outlet>
  </div>